module.exports = __webpack_public_path__ + "static/media/thumbs_dsc_2536.46fee424.jpg";